import { Schema } from "effect";
// Input schema for creating a webhook endpoint
export const WebhookEndpointCreate = Schema.Struct({
    url: Schema.String.pipe(Schema.nonEmptyString(), Schema.annotations({
        description: "The URL where webhook events will be sent",
        example: "https://example.com/webhook"
    })),
    description: Schema.optional(Schema.String.pipe(Schema.annotations({
        description: "A description of the webhook endpoint",
        example: "Production webhook for user events"
    }))),
    filterTypes: Schema.optional(Schema.Array(Schema.String).pipe(Schema.annotations({
        description: "Array of event types to filter for this endpoint",
        example: [
            "user.created",
            "user.updated"
        ]
    }))),
    headers: Schema.optional(Schema.Record({
        key: Schema.String,
        value: Schema.String
    }).pipe(Schema.annotations({
        description: "Custom headers to include with webhook requests",
        example: {
            "X-API-Key": "secret-key"
        }
    })))
});
// Output schema for webhook endpoint responses
export const WebhookEndpoint = Schema.Struct({
    id: Schema.String.pipe(Schema.annotations({
        description: "Unique identifier for the webhook endpoint",
        example: "ep_2kj3h4k5j6h7k8j9"
    })),
    url: Schema.String.pipe(Schema.annotations({
        description: "The URL where webhook events are sent",
        example: "https://example.com/webhook"
    })),
    description: Schema.NullOr(Schema.String).pipe(Schema.annotations({
        description: "Description of the webhook endpoint",
        example: "Production webhook for user events"
    })),
    version: Schema.Number.pipe(Schema.annotations({
        description: "API version for the webhook",
        example: 1
    })),
    disabled: Schema.Boolean.pipe(Schema.annotations({
        description: "Whether the webhook endpoint is disabled",
        example: false
    })),
    filterTypes: Schema.NullOr(Schema.Array(Schema.String)).pipe(Schema.annotations({
        description: "Event types this endpoint is subscribed to",
        example: [
            "user.created",
            "user.updated"
        ]
    })),
    channels: Schema.NullOr(Schema.Array(Schema.String)).pipe(Schema.annotations({
        description: "Channels this endpoint is subscribed to",
        example: [
            "user-events"
        ]
    })),
    createdAt: Schema.Union(Schema.String, Schema.Date).pipe(Schema.annotations({
        description: "ISO 8601 timestamp of when the endpoint was created",
        example: "2024-01-15T10:30:00Z"
    })),
    updatedAt: Schema.Union(Schema.String, Schema.Date).pipe(Schema.annotations({
        description: "ISO 8601 timestamp of when the endpoint was last updated",
        example: "2024-01-15T10:30:00Z"
    })),
    headers: Schema.optional(Schema.Record({
        key: Schema.String,
        value: Schema.String
    }).pipe(Schema.annotations({
        description: "Custom headers configured for this endpoint",
        example: {
            "X-API-Key": "secret-key"
        }
    })))
});
// List response schema with pagination
export const WebhookEndpointList = Schema.Struct({
    data: Schema.Array(WebhookEndpoint),
    done: Schema.Boolean.pipe(Schema.annotations({
        description: "Whether there are more results to fetch",
        example: false
    })),
    iterator: Schema.optional(Schema.String.pipe(Schema.annotations({
        description: "Iterator for fetching the next page of results",
        example: "ep_2kj3h4k5j6h7k8j9"
    }))),
    prevIterator: Schema.optional(Schema.String.pipe(Schema.annotations({
        description: "Iterator for fetching the previous page of results",
        example: "ep_1kj3h4k5j6h7k8j8"
    })))
});
// Schema for updating webhook headers
export const WebhookHeadersUpdate = Schema.Struct({
    headers: Schema.Record({
        key: Schema.String,
        value: Schema.String
    }).pipe(Schema.annotations({
        description: "Headers to set for the webhook endpoint",
        example: {
            "X-API-Key": "new-secret-key",
            "X-Custom-Header": "value"
        }
    }))
});
// URL parameters for listing webhooks
export const WebhookListParams = Schema.Struct({
    limit: Schema.optional(Schema.NumberFromString.pipe(Schema.annotations({
        description: "Maximum number of results to return",
        example: "20"
    }))),
    iterator: Schema.optional(Schema.String.pipe(Schema.annotations({
        description: "Iterator from previous response for pagination",
        example: "ep_2kj3h4k5j6h7k8j9"
    })))
});
